<template>
  <transition name="msg-pop-fade">
    <div v-if="show" class="msg-pop">
      <a href="javascript:;" class="close" @click="onClose" />
      <div v-html="modelMsg"></div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    duration: {
      type: Number,
      default: 1000 * 10
    }
  },
  data() {
    return {
      show: false,
      modelMsg: ''
    }
  },
  mounted() {
    this.getData()
  },
  destroyed() {
    this.clearTimer()
  },
  methods: {
    getData() {
      this.$request('gameHomePopups').then((data = {}) => {
        this.$set(this, 'modelMsg', data.content)
        this.show = true
        this.startTimer()
      })
    },
    onClose() {
      this.show = false
      this.clearTimer()
    },
    startTimer() {
      if (this.duration) {
        this.timer = setTimeout(() => {
          this.show = false
        }, this.duration)
      }
    },
    clearTimer() {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
    }
  }
}
</script>
<style>
.msg-pop img {
  max-width: 100%;
}
</style>
